import { IDeleteReasonResponse } from 'actions/catalog/models';
import { createContext } from 'react';

interface ISettingsContext {
  dataReasons?: IDeleteReasonResponse[];
}

export const SettingsContext = createContext({} as ISettingsContext);
